const common = {
  serverError: '服务器错误',
  networkError: '网络错误',

  del: '删除',
  rmTip: '删除提示',
  rmContent: '你确定要删除这个数据吗？删除后数据不可恢复！',
  rmError: '删除失败',
  rmSuccess: '删除成功',

  confirm: '确定',
  cancel: '取消',
  cancelConfirm: '数据有改动，确定不进行保存吗？',

  add: '添加',
  addError: '添加失败',
  addSuccess: '添加成功',

  edit: '编辑',
  editError: '编辑失败',
  editSuccess: '编辑成功',
  tip: '提示',

  opt: '操作',
  viewDetail: '查看详情',
  detail: '详情',

  desc: '描述',
  plDesc: '请输入描述',

  pass: "通过",
  no: "否",
  copy: '复制',
  copyError: '复制失败',
  copySuccess: '复制成功',

  printInfo: '打印',
  printInfoQC: '打印QC质检单',
  paste: '粘贴',
  pasteError: '粘贴失败, 请确认复制内容正常或重新复制后再试',

  select: '选择',
  searchError: '获取列表异常',

  timeOption12: "12小时",
  timeOption24: "1天",
  timeOption36: "36小时",
  timeOption48: "2天",
  timeOption72: "3天",
  timeOption96: "4天",
  timeOption120: "5天",
  currentTime: "当前时间",
  selectTime: "请选择或填入可供供应商报价的时间段",
  or: "或",
  inputHours: "输入小时数",
  hour: "小时",
  finalEnd: "最终报价截止时间",
  upper: "当前时间向上取整后",
  plus: "加上",

  refresh: "刷新",
  sure: '确定要保存吗？',
  saveOk: '保存成功',
  saveFAil: '保存失败',
  save: '保存',
  notSave: '不保存',
  validateFailed: '表单校验失败',

  createTime: '制单时间',
  creator: '制单人',
  updateTime: '更新时间',
  updater: '更新人',
  pleaseTryAgain: '请稍后重试',
  operationFailed: '操作失败',

  exportCurrentPage: '导出当页Excel',
  exportAllExcel: '导出全部Excel',
  exporting: '正在导出',
  exportingTip: '正在批量加载数据，请稍候...',
  exportErr: '导出失败',
  warning: '警告',
  pleaseSelectColumns: '请至少选择一列进行导出',
  selectAll: '全选',
  expand: '展开更多',
  collapse: '收起',

  // 报销类目
  code: '编码',
  name: '名称',
  sortOrder: '排序',
  update: '更新',
  updateSuccess: '更新成功',
  addSub: '添加子类目',
  disable: '禁用',
  plSelect: '请选择',

  basicInfo: '基本信息',
  attachment: '附件',
  noOutOrder: '没有出库单',
  deleteSuccess: '删除成功',
  deleteFail: '删除失败',
  batchDel: '批量删除',
  selectLeastOne: '请至少选择一项',
  versionFalse: "请求发起失败，您的版本不正确，请您刷新页面重试",
  po: "采购订单",
  poi: "采购订单条目",
  so: "销售订单",
  soi: "销售订单条目",
  io: "入库单",
  ioi: "入库单条目",
  oo: "出库单",
  ooi: "出库单条目",
  co: "盘点单",
  coi: "盘点单条目",
  act: "应收",
  acti: "应收条目",
  pay: "应付",
  payi: "应付条目",
  req: "需求单",
  reqi: "需求单条目",
  quo: "问询单",
  loc: "库位",
  sp: "销售价格",
  pp: "采购价格",
  cd: "盘点差异",
  user: "用户/user",
  org: "组织/org",
  supplier: "供应商",
  bom: "BOM",
  pl: "生产计划",
  reqest: "申请",
  export: "导出",
  inventories: "送货单",
  matPurTmp: "匹配采购单模版下载",
  genPuInv: "匹配采购单生成送货单",
  suppInv: "匹配供应商生成送货单",
  printSaleIn: "成品入库打印",
  saleIn: "成品入库",
  lotGetErr: "批次生成失败，请联系管理员",
  addNext: "下一个",
  genLot: "生成",
  noCodeWarn: "没有存货编码的条目不会生成批次",
  genAllLot: "一键生成批次",
  colSet: "选择显示列",
  leastSetOneCol: "至少选择一列显示！",
  reqCanceled: "查询请求已取消",
  escPressed: "您按下了 ESC，取消了这个查询请求",
  noFiles: "没有文件",
  allFile: "全部附件",
};

export default common;
